import styled from 'styled-components';

import { Container as BaseContainer } from 'components/Container';

export const Container = styled(BaseContainer).attrs(() => ({
  manageLayout: false,
}))`
  text-align: center;
`;
